import {useState} from "react";
import {useHistory} from "react-router-dom";
import {useFactors} from "../contexts/FactorsContext";
import {Container, Row} from "../components/common";
import {CBBody, CBHeader, ContentBox} from "../components/common/ContentBox";
import MfaIcon from "../../images/icon_mfa.png";
import RemarkImage from "../../images/remark.png";
import {equalsIgnoreCase} from "../utils/strings";
import {resetFactor} from "../services/api/factorApi";
import {runApi} from "../services/api/ApiContext";
import {toast} from "react-toastify";

const showFactor = [
	{type: 'push', provider: 'OKTA', name: 'Okta Verify', order: 1},
	{type: 'token:software:totp', provider: 'OKTA', name: 'Okta Verify', order: 1},

	{type: 'token:software:totp', provider: 'google', name: 'Google / Microsoft Authenticator', order: 2},
	{type: "email", provider: "OKTA", name: "Email Authentication", order: 3},
	{type: "sms", provider: "OKTA", name: "SMS Authentication", order: 4},
	{type: "call", provider: "OKTA", name: "Voice Call Authentication", order: 5},
	{type: 'webauthn', provider: 'FIDO', name: 'Security Key or Biometric Authenticator', order: 6},
	{type: 'token:hotp', provider: 'CUSTOM', name: 'CityU Authenticator', order: 7},
]

const patchFactors = (factors) => {
	// console.log(factors)
	factors = factors?.map(patchFactor).filter((f) => !!f);
	factors = mergeOktaVerify(factors);
	factors = addFidoDisplay(factors);
	factors = filterFactorStatus(factors);
	factors?.sort((a, b) => a.order - b.order);

	console.log(factors);

	return factors;
}

const patchFactor = (factor) => {
	for (const showFactorElement of showFactor) {
		if (equalsIgnoreCase(factor.type, showFactorElement.type)
			&& equalsIgnoreCase(factor.provider, showFactorElement.provider)) {
			factor = {
				name: showFactorElement.name,
				order: showFactorElement.order,
				...factor,
			};
			return factor;
		}
	}

	return null;
}

const mergeOktaVerify = (factors) => {
	if (!factors) {
		return factors;
	}

	const hasOktaPush = factors.filter((f) => equalsIgnoreCase(f.type, 'push') && equalsIgnoreCase(f.provider, "OKTA")).length > 0;

	if (!hasOktaPush) {
		return factors;
	}

	return factors.filter((f) => !(equalsIgnoreCase(f.type, 'token:software:totp') && equalsIgnoreCase(f.provider, "OKTA")));

	// for (const [index, factor] of factors?.entries()) {
	// 	if (equalsIgnoreCase(factor.type, "push") && equalsIgnoreCase(factor.provider, "OKTA")) {
	// 		if (!factor.id) {
	// 			factors.splice(index, 1);
	// 		} else {
	// 			factors = factors.filter(f => !equalsIgnoreCase(f.type, "token:software:totp") || !equalsIgnoreCase(f.provider, "OKTA"))
	// 		}
	// 		return factors;
	// 	}
	// }
	//
	// return factors;
}

const addFidoDisplay = (factors) => {
	const fido = factors?.filter((f) => equalsIgnoreCase(f.type, "webauthn") && equalsIgnoreCase(f.provider, "FIDO") && equalsIgnoreCase(f.status, "ACTIVE"));

	if (!fido || fido?.length === 0) {
		return factors;
	}

	const withoutFifo = factors?.filter((f) => !(equalsIgnoreCase(f.type, "webauthn") && equalsIgnoreCase(f.provider, "FIDO")));

	const fidoDisplay = {...fido[0]};
	fidoDisplay.id = null;
	fidoDisplay.profile = null;
	fidoDisplay.status = 'NOT_SETUP';
	fidoDisplay.exist = true;

	return [...withoutFifo, fidoDisplay, ...fido];
}

const filterFactorStatus = (factors) => {
	if (!factors) {
		return factors;
	}

	// factors

	return factors;
}

const handleResetFactor = async (factorId, refresh) => {
	async function resetFactorFromApi() {
		const resetFactorResponse = await runApi(
			'resetFactor',
			() => resetFactor(factorId)
		);

		if (!resetFactorResponse?.data?.data) {
			return;
		}

		toast.success("Reset factor successfully");
	}

	await resetFactorFromApi();

	refresh();
}

const MFASetupView = () => {
	const {data, refresh} = useFactors();
	const history = useHistory();
	const [editMode, setEditMode] = useState(false);

	const setUpFactor = (type, provider) => {
		history.push(`/profile/mfa/enroll/${provider}/${type}`);
	};

	const factors = patchFactors(data?.factors);

	// let factors = data?.factors?.map(patchFactor).filter((f) => !!f);
	// console.log(data?.factors);
	// factors?.sort((a, b) => a.order - b.order);
	// if (factors) {
	// 	factors = mergeOktaVerify(factors);
	// }

	const editEvent = () => {
		setEditMode(true);
	}

	const cancelEditEvent = () => {
		setEditMode(false);
	}

	const renderFactorOptions = (factor) => {
		if (equalsIgnoreCase(factor.type, "webauthn") && equalsIgnoreCase(factor.provider, "FIDO")) {
			if (equalsIgnoreCase(factor.status, "ACTIVE")) {
				// if (factor.id) {
				return (
					<p key={factor.type + factor.provider}>
						{'- ' + (factor.profile.authenticatorName ?? 'Authenticator')}
						{!editMode && <span>Enabled</span>}
						{editMode && <button onClick={() => handleResetFactor(factor.id, refresh)}>Remove</button>}
					</p>
				);
			} else {
				return (
					<p key={factor.type + factor.provider}>
						{factor.name}
						{editMode && <button onClick={() => setUpFactor(factor.type, factor.provider)}>Set up</button>}
						{!editMode && !factor.exist && <span>Disabled</span>}
					</p>
				);
			}
		}

		return (
			<p key={factor.type + factor.provider}>
				{factor.name}
				{!editMode && factor.id && equalsIgnoreCase(factor.status, "ACTIVE") && <span>Enabled</span>}
				{!editMode && !(factor.id && equalsIgnoreCase(factor.status, "ACTIVE")) && <span>Disabled</span>}
				{editMode && factor.id && equalsIgnoreCase(factor.status, "ACTIVE") &&
					<button onClick={() => handleResetFactor(factor.id, refresh)}>Remove</button>}
				{editMode && !(factor.id && equalsIgnoreCase(factor.status, "ACTIVE")) &&
					<button onClick={() => setUpFactor(factor.type, factor.provider)}>Set up</button>}
			</p>
		);
	}

	return (
		<Container>
			<h1>Set up MFA</h1>

			<Row>
				<div className="col-12 col-lg-6">
					<ContentBox>
						<CBHeader
							icon={MfaIcon}
							title={'SET UP MFA'}
							showEdit={true}
							isEdit={editMode}
							editEvent={() => editEvent()}
							cancelEditEvent={() => cancelEditEvent()}
						/>
						<CBBody>
							<p className="red">
								<span>Multi-Factor Authentication mechanism</span>
								<span className="remark">
									<img src={RemarkImage} alt={''}/>
									<span className="popup-red">Multi-Factor Authentication mechanism, once setup, will further secure your CityU EID by requiring you to authenticate once again in sensitive applications such as AIMS with a device you owned and brought with you always.  Hackers will not be able to login the system even they got your password.</span>
								</span>
							</p>

							<div className="setup-item">
								{factors && factors.map(factor => renderFactorOptions(factor))}
								{!factors && 'Loading...'}
							</div>
						</CBBody>
					</ContentBox>
				</div>
			</Row>
		</Container>
	);
}

export default MFASetupView;
